export default __webpack_public_path__ + "static/media/rookiewise.theme.3dc93720.less";